interface KakaoArg {
  title: string;
  description: string;
  path: string;
  email?: string;
}

export const copyClipboard = async () => {
  const url = window.location.href;
  try {
    await navigator.clipboard.writeText(url);
  } catch (error) {
    console.error(error);
  }
};

/* templateId 카카오 sdk 확인  */
export const sendKakaoLinkShare = (linkData: KakaoArg) => {
  const { title, description, path, email } = linkData;
  if (window.Kakao) {
    const Kakao = window.Kakao;
    Kakao.Link.sendCustom({
      templateId: 67397,
      templateArgs: {
        title: `${title}`,
        description: `${description}`,
        path: `${path}`,
      },
      serverCallbackArgs: `{
          "path": "${path}",
          "email": "${email}"
        }`,
    });
  }
};
